import { useUser } from 'context/UserContext';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { toast } from 'react-toastify';

const IsPrefect = () => {
  const user = useUser();
  if (!user.prefect) {
    toast.warning('Non hai accesso a questa pagina');
    return <Navigate to="/classe" />;
  }
  return <Outlet />;
};

export default IsPrefect;
